import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import collapse from '@alpinejs/collapse';
import LazyLoad from "vanilla-lazyload";
import simpleParallax from 'simple-parallax-js';
import Tooltip from '@ryangjchandler/alpine-tooltip';
/**
 * Initialise lazy loading of all image on the site.
 */
if (!document.lazyLoadInstance) {
    document.lazyLoadInstance = new LazyLoad({elements_selector: ".lazy"});
}

/**
 * Initialise parallax
 */
let parallaxImage = document.getElementsByClassName('parallax');

for(let i = 0; i < parallaxImage.length; i++){
    const container = parallaxImage[i].closest('.row-background');

    new simpleParallax(parallaxImage[i], {
        customWrapper: '.row-background',
        scale: 1.5,
    });

}




/**
 * Import all JS from the global folder and all components folder to compile
 */
import.meta.glob('../../../global/**/*.js',{ eager: true });
import.meta.glob('../../../../components/**/*.js',{ eager: true });

/**
 * Import the main SASS folder to compile
 */
import '../sass/main.scss';

/**
 * Initialise Alpine JS and the intersect and collapse plugin
 */
Alpine.plugin(intersect);
Alpine.plugin(collapse);
Alpine.plugin(Tooltip);
window.Alpine = Alpine
Alpine.start();